import { defineStore } from 'pinia';
import AuthService from '@/services/auth.service';


export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    isLoading: false,
    isAuthenticated: false,
    tokenRefreshInterval: null,
  }),

  getters: {
    isLoggedIn: (state) => state.isAuthenticated && !!state.user,
  },

  actions: {
    async register(credentials) {
      this.isLoading = true
      try {
        const response = await AuthService.register(credentials)
        return response
      } catch (error) {
        console.error('Register failed:', error)
        throw error
      } finally {
        this.isLoading = false
      }
    },

    async login(credentials) {
      this.isLoading = true;
      try {
        const response = await AuthService.login(credentials);
        this.user = response.user;
        this.isAuthenticated = true;
        await this.fetchUser(); // Récupère les infos complètes de l'utilisateur
        this.startTokenRefreshInterval(); // Lance le renouvellement auto
      } catch (error) {
        console.error('Login failed:', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    async logout() {
      this.isLoading = true;
      try {
        this.stopTokenRefreshInterval(); // Arrête le renouvellement
        await AuthService.logout();
        this.user = null;
        this.isAuthenticated = false;
      } catch (error) {
        console.error('Logout failed:', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    // Cette méthode ne récupère que l'email de l'utilisateur, à réfléchir si besoin de plus d'infos (changer backend aussi)
    async fetchUser() {
      this.isLoading = true;
      try {
        const response = await AuthService.fetchUser();
        this.user = response;
        this.isAuthenticated = true;
      } catch (error) {
        console.error('Fetch user failed:', error);
        this.user = null;
        this.isAuthenticated = false;
      } finally {
        this.isLoading = false;
      }
    },

    async refreshToken() {
      this.isLoading = true;
      try {
        await AuthService.refreshToken();
        await this.fetchUser(); // Refresh user data after token refresh
      } catch (error) {
        console.error('Refresh token failed:', error);
        this.logout(); // Logout if refresh fails
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    startTokenRefreshInterval() {
      // Renouvelle le token toutes les 50 min (avant l'expiration d'1h)
      if (this.tokenRefreshInterval) {
        clearInterval(this.tokenRefreshInterval);
      }

      this.tokenRefreshInterval = setInterval(() => {
        if (this.isAuthenticated) {
          this.refreshToken().catch(() => {
            // Logout si refresh échoue
            this.stopTokenRefreshInterval();
          });
        }
      }, 50 * 60 * 1000); // 50 minutes
    },

    stopTokenRefreshInterval() {
      if (this.tokenRefreshInterval) {
        clearInterval(this.tokenRefreshInterval);
        this.tokenRefreshInterval = null;
      }
    },

    async initAuth() {
      try {
        await this.fetchUser();
        if (this.isAuthenticated) {
          this.startTokenRefreshInterval(); // Lance le renouvellement auto si utilisateur loggé
        }
      } catch (error) {
        console.error('Auth init failed:', error);
      }
    },
  },
});